<template>
  <layout-basic>
    <page-hero
      title="We'd Love to Hear From You"
      lead="Whether you have a question, need advice or would like a demonstration, we're here to help."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="home" />
      </v-container>
    </section>

    <section class="contact-channels">
      <v-container>
        <div class="contact-channels__grid">
          <a class="contact-channels__card" href="tel:01156786278">
            <strong>Call</strong>
            <span>0115 6786278</span>
          </a>
          <a class="contact-channels__card" href="mailto:help@improve.online">
            <strong>Email</strong>
            <span>help@improve.online</span>
          </a>
          <a class="contact-channels__card" href="/contact">
            <strong>Book a Meeting</strong>
            <span>Use the form below</span>
          </a>
          <a class="contact-channels__card" href="mailto:info@improve.online">
            <strong>Support</strong>
            <span>info@improve.online</span>
          </a>
        </div>
      </v-container>
    </section>

    <v-container>
      <section class="container-new pricing-section contact-form-section">
        <v-row>
          <v-col cols="12" md="6">
            <h2 class="font-sora contact-title">
              Contact our team to receive a free demonstration
            </h2>
            <p class="mt-4 contact-detail">
              <img class="mr-2" src="static/icons/envelope.png" alt="" /><a
                class="fs-22"
                href="mailto:help@improve.online"
                >help@improve.online</a
              >
            </p>
            <p class="contact-detail">
              <img class="mr-2" src="static/icons/phone.png" alt="" /><a
                class="fs-22"
                href="tel:01156786278"
                >0115 6786278</a
              >
            </p>
          </v-col>
          <v-col cols="12" md="6">
            <div class="relative">
              <v-content>
                <v-card class="elevation-12 contact-us-form" fill-height>
                  <v-card-text>
                    <v-form ref="form" @submit.prevent="submitForm">
                      <!-- Honeypot: off-screen, invisible to real users. Bots that auto-fill every field are dropped server-side. -->
                      <input type="text" v-model="company_website" name="company_website" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;overflow:hidden;" />
                      <p>First Name:</p>
                      <v-text-field
                        v-model="first_name"
                        :rules="[rules.required, rules.name]"
                        label="First Name:"
                        type="text"
                        placeholder="John"
                        solo
                        hide-details="auto"
                      ></v-text-field>
                      <p>Last Name:</p>
                      <v-text-field
                        v-model="last_name"
                        :rules="[rules.required, rules.name]"
                        label="Last Name:"
                        type="text"
                        placeholder="Smith"
                        solo
                        hide-details="auto"
                      ></v-text-field>
                      <p>Company Name:</p>
                      <v-text-field
                        v-model="company_name"
                        :rules="[rules.required]"
                        label="Company Name"
                        placeholder="Smith Inc"
                        solo
                        hide-details="auto"
                      ></v-text-field>
                      <p>Email Address:</p>
                      <v-text-field
                        v-model="email"
                        :rules="[rules.required, rules.email]"
                        label="Email"
                        placeholder="johnsmith@email.com"
                        solo
                        type="email"
                        hide-details="auto"
                      ></v-text-field>
                      <p>Message:</p>
                      <v-textarea
                        v-model="messages"
                        :rules="[rules.required]"
                        label="Messages"
                        placeholder="Hi, Hello, Bonjour"
                        solo
                        hide-details="auto"
                      ></v-textarea>

                      <div id="newsletter">
                        <v-checkbox
                          style="box-shadow: none !important;"
                          v-model="newsletter"
                          :label="
                            `Sign up for our newsletter to receive the latest news from IMPROVE.`
                          "
                        ></v-checkbox>
                      </div>
                      <div class="text-center mt-10">
                        <v-btn
                          :loading="loading"
                          class="demo-submit-btn"
                          type="submit"
                          depressed
                        >
                          Contact Us
                        </v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-content>
            </div>
          </v-col>
        </v-row>
      </section>
    </v-container>

    <standard-cta
      title="Ready to transform employee learning?"
      lead="Watch the demo or experience IMPROVE for yourself."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import AuthAPI from '@/Api/auth.js';
import PageHero from '@/components/marketing/PageHero.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'Contact',
  components: {
    LayoutBasic,
    PageHero,
    StandardCta,
    DemoVideo,
  },
  data: () => ({
    errorMessages: {},
    password: '',
    email: '',
    first_name: '',
    last_name: '',
    company_name: '',
    messages: '',
    newsletter: false,
    company_website: '',
    successMessage:
      'We have notified our team with your request. Some one from our team will be in touch shortly.',
    loading: false,
    rules: {
      required: (value) => !!value || 'Required.',
      email: (value) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(value) || 'Invalid email.';
      },
      name: (value) =>
        (value && value.length >= 2) || 'Name must be at least 2 characters.',
    },
  }),
  metaInfo() {
    return marketingPageMeta({
      title: "We'd Love to Hear From You | IMPROVE",
      description:
        "Whether you have a question, need advice or would like a demonstration, we're here to help.",
      path: '/contact',
    });
  },
  methods: {
    submitForm() {
      if (this.$refs.form.validate()) {
        this.contactUs();
      }
    },
    contactUs() {
      this.loading = true;
      AuthAPI.contactUs({
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        company_name: this.company_name,
        messages: this.messages,
        newsletter: this.newsletter,
        company_website: this.company_website,
      })
        .then(() => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
        })
        .catch((err) => {
          this.valid = false;
          this.loading = false;
          this.errorMessages = this.$gf.errorResponse(err);
        });
    },
  },
};
</script>

<style scoped>
.contact-channels {
  padding: 8px 0 24px;
}

.contact-channels__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  max-width: 980px;
  margin: 0 auto;
}

.contact-channels__card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  padding: 20px 16px;
  text-decoration: none;
  color: var(--brand-navy, #002458);
  text-align: center;
  transition: border-color 0.15s ease;
}

.contact-channels__card:hover {
  border-color: var(--brand-teal, #08a0a8);
  color: var(--brand-navy, #002458);
}

.contact-channels__card strong {
  font-size: 16px;
}

.contact-channels__card span {
  color: var(--brand-grey, #6b7280);
  font-size: 14px;
}

.contact-form-section {
  padding-bottom: 48px;
}

.contact-title {
  color: var(--brand-navy, #002458);
  font-size: 28px;
  line-height: 1.35;
}

.contact-detail a {
  color: var(--brand-navy, #002458);
  text-decoration: none;
}

.contact-detail a:hover {
  color: var(--brand-teal, #08a0a8);
}

.demo-submit-btn {
  background-color: var(--brand-navy, #002458) !important;
  color: #ffffff !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  letter-spacing: 0.02em !important;
  padding: 12px 36px !important;
  border-radius: 6px !important;
  min-height: 48px;
}

.demo-submit-btn:hover {
  background-color: var(--brand-teal, #08a0a8) !important;
}

@media screen and (max-width: 900px) {
  .contact-channels__grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 600px) {
  .contact-channels__grid {
    grid-template-columns: 1fr;
  }
}
</style>
